import React from 'react';
import './style.scss';

export default ({sportId}) => <span className={`line-sport-menu-item-ico f-s-ico-${sportId} LiveMenu-IconSport`} />;


// WEBPACK FOOTER //
// ./src/components/liveMenu/-IconSport/index.jsx